<template>
    <transition name="fade" mode="out-in">
        <section
            class="padding-vertical-content  mb-3 mb-lg-4"
            v-if="mostrar"
            key="preguntaParcelas"
            id="preguntaParcelas"
        >
            <div class="container">
                <div class="row">
                    <b-col cols="12">
                        <template v-if="teatro.hash === 'J1fKG9AarPuPNJ5hwY0t'">
                            <h2 class="h1 text-uppercase mb-3">{{ $t('nuevo_abono.titulo_pregunta') }}</h2>
                            <div class="subtitle light mb-3">
                                <div class="d-block d-md-inline">{{ $t('nuevo_abono.descripcion_pregunta_parcela') }}</div>
                                <a href="https://storage.compralaentrada.com/PDF/realmurcia/EL%20TERRENO%20DE%20TUS%20SUE%C3%91OS%20CAMPA%C3%91A%20DE%20ABONADOS%20REAL%20MURCIA%20TEMPORADA%202025-2026" target="_blank" class="text-primary subtitle d-block d-md-inline mt-2"> Más información</a>
                            </div>
                        </template>
                        <template v-else>
                            <h2 class="h1 text-uppercase">{{ $t('nuevo_abono.titulo_pregunta') }}</h2>
                            <div class="subtitle h3 light mb-3">
                                {{ $t('nuevo_abono.descripcion_pregunta_parcela') }}
                            </div>
                        </template>
                    </b-col>
                    <b-col cols="12">
                        <b-row class="mt-4">
                            <b-col cols="12" md="auto">
                                <Button
                                    type="button"
                                    :label="$t('nuevo_abono.si_quiero')"
                                    :disabled="loading || botonesDeshabilitados"
                                    @click="comprarParcelas"
                                />

                                <Button
                                    type="button"
                                    :label="$t('nuevo_abono.no_continuar')"
                                    :disabled="loading || botonesDeshabilitados"
                                    custom-class="ml-2"
                                    @click="continuarSinParcelas"
                                />

                                <Button
                                    id="atras"
                                    type="button"
                                    :label="$t('nuevo_abono.atras')"
                                    :disabled="loading || botonesDeshabilitados"
                                    custom-class="ml-2 mt-2"
                                    @click="volver"
                                />
                            </b-col>
                        </b-row>
                    </b-col>
                </div>
            </div>
        </section>
    </transition>
</template>

<script setup>
    import { computed } from 'vue';
    import store from '@/store';
    import Button from '@/modules/ui/Button.vue';

    const teatro = computed(() => store.getters.getTeatro);

    const props = defineProps({
        mostrar: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        botonesDeshabilitados: {
            type: Boolean,
            default: false
        }
    });

    const emit = defineEmits(['quiereParcelas', 'volver']);

    const comprarParcelas = () => {
        emit('quiereParcelas', true);
    };

    const continuarSinParcelas = () => {
        emit('quiereParcelas', false);
    };

    const volver = () => {
        emit('volver');
    };
</script>

<style>
.fade-enter-active, .fade-leave-active {
    transition: opacity .2s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}

@media (min-width: 397px) {
    #atras {
        margin-top: 0 !important;
        margin-left: 0.5rem !important;
    }
}
</style>
